import { useMutation, useQueryClient } from '@tanstack/react-query'
import { type ApiResponseError, fetchApiWithToken } from '~/api/utils'
import { ToastType } from '~/components/Global/Interactions/Toast/ToastType'
import { toast } from '~/utils'

type UpdateApplicantAvailabilityPayload = {
  date: string
  createUnavailability: boolean
  unavailabilityEnd?: string
}

type UpdateApplicantAvailabilityResponse = {
  success: boolean
  lastAvailabilityDate: string
}

export const useUpdateApplicantAvailability = (applicantId: number) => {
  const queryClient = useQueryClient()

  return useMutation<
    UpdateApplicantAvailabilityResponse,
    ApiResponseError,
    UpdateApplicantAvailabilityPayload
  >({
    mutationFn: (payload) =>
      fetchApiWithToken<UpdateApplicantAvailabilityResponse>({
        method: 'post',
        url: `/v1/applicants/${applicantId}/availability`,
        data: payload
      }),
    onSuccess: () => {
      void queryClient.invalidateQueries({
        queryKey: ['applicants', applicantId]
      })
      void queryClient.invalidateQueries({
        queryKey: ['applicants', 'availability', applicantId]
      })
      void queryClient.invalidateQueries({
        queryKey: ['applicant', applicantId, 'history']
      })

      toast('Disponibilité mise à jour.', '', ToastType.Success)
    },
    onError: (error) => {
      const message =
        error.response?.error ||
        error.response?.message ||
        'Erreur lors de la mise à jour'
      toast('Erreur', message, ToastType.Danger)
    }
  })
}
